import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submitButton"]

  connect() {
    this.submitButtonTarget.classList.add("invisible")

    for (const input of this.element.elements) {
      if ("action" in input.dataset) {
        input.dataset.persistedValue = input.value
      }
    }
  }

  toggle(event) {
    if (event.target.dataset.persistedValue === event.target.value) {
      this.submitButtonTarget.classList.add("invisible")
    } else {
      this.submitButtonTarget.classList.remove("invisible")
    }
  }
}
